/* eslint-disable */
import type { Animation } from "../../cash/ui/Animation.pb";
import type { LoanAmountPicker } from "../../lending/loan_amount_picker.pb";

export interface CreditAnimationBlocker {
  /** The header text. Not optional. */
  header?: string;
  /** The subheader text. Not optional. */
  subheader?: string;
  /** The continue through the flow button text. Not optional. */
  button_text_continue?: string;
  /** The request more info button text. Optional. */
  button_text_more_info?: string;
  /** A remote animation with given information. Not optional. */
  animation?: Animation;
  /** Follow up to show the loan picker screen. Not optional. */
  amount_picker_screen?: LoanAmountPicker;
  /** Follow up to show additional info about borrow. Optional. */
  limit_info_screen?: CreditAnimationBlockerLimitInfoScreen;
}

/** Data for the half sheet explaining to users how credit limits are calculated. */
export interface CreditAnimationBlockerLimitInfoScreen {
  /** The header text. Not optional. */
  header?: string;
  /** The subtitle text. Not optional. */
  subtitle?: string;
  /** The detail rows. Not optional. */
  detail_rows?: CreditAnimationBlockerLimitInfoScreenDetailRow[];
  /** The title for the dismiss button. Not optional. */
  dismiss_button_title?: string;
}

/**
 * Data to populate detail rows. A cell with an icon, a title,
 * and a subtitle.
 */
export interface CreditAnimationBlockerLimitInfoScreenDetailRow {
  /** The icon. Not optional. */
  icon?: CreditAnimationBlockerLimitInfoScreenDetailRowIcon;
  /** The title text. Not optional. */
  title?: string;
  /** The subtitle text. Not optional. */
  subtitle?: string;
}

export enum CreditAnimationBlockerLimitInfoScreenDetailRowIcon {
  CARD = "CARD",
  DEPOSIT = "DEPOSIT",
  BANK = "BANK",
}
